module.exports = __webpack_public_path__ + "static/img/cabecera.5977a7b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/regimen-en/cabecera.jpg
// module id = O5dg
// module chunks = 0